import { Box, Flex } from '@chakra-ui/react';
import { SearchInput } from './components/SearchInput';
import { AISpinner } from './components/AISpinner';
import { RecentlyUsed } from './components/RecentlyUsed';
import { SearchResultsView } from './components/SearchResultsView';
import { useAISearch } from './hooks/useAISearch';
import { VIEW } from './constants';

const AISearchContainer = ({ onClose }: { onClose: () => void }) => {
  const search = useAISearch();

  const showRecentlyViewed = search.currentView === VIEW.RECENTLY_VIEWED;
  const showResultsView = search.currentView === VIEW.RESULTS;

  return (
    <Box
      minW="63rem"
      maxW="63rem"
      mt="6px"
      mx="auto"
      className="ai-search-container"
    >
      <Box className="ai-search-input-container">
        <SearchInput
          onInputEnter={search.handleSearch}
          externalSearchTerm={search.externalSearchTerm}
          onClose={search.handleClose}
          isLoading={search.isLoading}
          onCancelSearch={search.cancelSearch}
        />
      </Box>

      <Flex {...search.searchResultsContainerProps}>
        {showRecentlyViewed && (
          <RecentlyUsed
            recentSearchQueries={search.recentSearchQueries}
            recentlyViewedCandidates={search.recentlyViewedCandidates}
            selectedIndex={search.selectedIndex}
            onSearchQueryClick={search.handleRecentQueryClick}
          />
        )}

        {showResultsView && search.isLoading && (
          <Flex justify="center" align="center" w="100%" h="100%" flex="1">
            <AISpinner />
          </Flex>
        )}

        {showResultsView && !search.isLoading && (
          <SearchResultsView
            tabItems={search.tabItems}
            selectedTab={search.selectedTab}
            onTabSelect={search.setSelectedTab}
            searchResults={search.searchResults}
            flows={search.flows}
            flowsIsLoading={search.flowsIsLoading}
            summaryInProgress={search.summaryInProgress}
            selectedIndex={search.selectedIndex}
            hasError={search.hasError}
            onSearchClose={onClose}
          />
        )}
      </Flex>
    </Box>
  );
};

export { AISearchContainer };
